import { render, staticRenderFns } from "./ExpencesCategoriesRoot.vue?vue&type=template&id=4c025ae4&scoped=true"
import script from "./ExpencesCategoriesRoot.vue?vue&type=script&lang=js"
export * from "./ExpencesCategoriesRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c025ae4",
  null
  
)

export default component.exports